import React from "react";
import styled, { keyframes, css } from "styled-components";
import { useTranslation } from "react-i18next";

const borderAnimation = keyframes`
  0%   { border-color: #00e5ff; box-shadow: 0 0 8px #00e5ff; }
  20%  { border-color: #ff00ff; box-shadow: 0 0 12px #ff00ff; }
  40%  { border-color: #39ff14; box-shadow: 0 0 12px #39ff14; }
  60%  { border-color: #ffa500; box-shadow: 0 0 12px #ffa500; }
  80%  { border-color: #8e44ad; box-shadow: 0 0 12px #8e44ad; }
  100% { border-color: #00e5ff; box-shadow: 0 0 8px #00e5ff; }
`;

const TimelineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  gap: 1rem;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

const Card = styled.div`
  flex: 1 1 0;
  min-width: 160px;
  max-width: 220px;
  background: linear-gradient(to bottom, #f2eaff, #ffffff);
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2rem;
  margin-bottom: 1rem;
  position: relative;
  border: 3px solid transparent;

  ${(props) =>
    props.highlight &&
    css`
      border: 3px solid #00e5ff;
      animation: ${borderAnimation} 4s linear infinite;
    `}
`;

const CardHeader = styled.div`
  background: ${(props) =>
    props.gradient ||
    `linear-gradient(180deg, ${props.bg || "#6c757d"} 0%, #ffffff 100%)`};
  color: white;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0.6rem 0.75rem;
  border: 3px solid #ffffff;
  border-radius: 10px;
  position: absolute;
  top: -1.2rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

const CardBody = styled.div`
  padding: 2rem 1rem 1.5rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 1.05rem;
  color: #000;
  height: 100%;
  justify-content: center;
`;

const timelineData = [
  {
    date: "01 Aug 2025",
    title: "Launch",
    gradient: "linear-gradient(180deg, #8e44ad 60%, #561a9cff 100%)",
  },
  {
    date: "Extended to 17 Sep",
    title: "Last date of Project submissions",
    gradient: "linear-gradient(180deg, #168aad 50%, #0d6d7cff 100%)",
    highlight: true,
  },
  {
    date: "End Sep",
    title: "Evaluation of Entries",
    gradient: "linear-gradient(180deg, #f57c00 50%, #b1761dff 100%)",
  },
  {
    date: "Mid Oct",
    title: "Mentoring of shortlisted entries",
    gradient: "linear-gradient(180deg, #3f51b5 50%, #29337bff 100%)",
  },
  {
    date: "End Oct",
    title: "Final round of Evaluation",
    gradient: "linear-gradient(180deg, #d81b60 50%, #822d49ff 100%)",
  },
  {
    date: "Nov",
    title: "Declaration of winners",
    gradient: "linear-gradient(180deg, #2e7d32 50%, #1d4e17ff 100%)",
  },
];

const Timeline = () => {
  const { t } = useTranslation();
  return (
    <div className="container">
      <h2 className="text-center mt-4">{t("timeline_heading_text")}</h2>
      <TimelineWrapper className="mt-3 mt-md-5">
        {timelineData.map((item, index) => (
          <Card key={index} highlight={item.highlight}>
            <CardHeader gradient={item.gradient} bg={item.bg}>
              {item.date}
            </CardHeader>
            <CardBody>{item.title}</CardBody>
          </Card>
        ))}
      </TimelineWrapper>
    </div>
  );
};

export default Timeline;
